import { useEffect, useState } from "react";
import CreateNotesPage from "../../../../../../entities/DashboardPage/AccountingModule/Customer/Notes/CreateNotes";
import LoaderHelper from "../../../../../../utils/Loader/LoaderHelper";
import { useAlert } from "../../../../../../context/AlertContext";
import AuthService from "../../../../../../api/AuthService";
import { useNavigate } from "react-router-dom";
import CreateSalesOrderPage from "../../../../../../entities/DashboardPage/AccountingModule/Customer/SalesOrder/CreateSalesOrder";

const CreateSales = () => {
  const { showAlert } = useAlert(); 
  const [loading , setLoading] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [items, setItems] = useState([]);
  const navigate = useNavigate()

  useEffect(() => {
    fetchInitialData();
  }, []);

  const fetchInitialData = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const [customerRes, itemsRes] = await Promise.all([
        AuthService.getCustomer(),
        AuthService.getItemsList(),
      ]);

      if (customerRes?.success) {
        setCustomers(customerRes.data.customers);
      }

      if (itemsRes?.success) {
        setItems(itemsRes.data.items);
      }

      LoaderHelper.loaderStatus(false);
    } catch (error) {
      showAlert("Failed to load data", "error");
      LoaderHelper.loaderStatus(false);
    }
  };

  const createSalesOrder = async (salesData) => {
    LoaderHelper.loaderStatus(true);
    setLoading(true);
    try {
      const result = await AuthService.createSalesOrder(salesData);
      if (result?.success) {
        setLoading(false);
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "success");
        navigate("/dashboard/salesHome");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
        LoaderHelper.loaderStatus(false)
      }
    } catch (apiError) {
      setLoading(false);
      LoaderHelper.loaderStatus(false);
      return;
    }
  }

  return (
    <CreateSalesOrderPage
      customerList={customers}
      itemList={items}
      createSalesOrder={createSalesOrder}
      loading={loading}
    />
  )
};
export default CreateSales;
